export default "__VITE_ASSET__BSM7j7kl__"